
// Initialize or get the swiper scripts manager
if (!window.swiperScriptsManager) {
  window.swiperScriptsManager = {
    swiperLoaded: false
  };
}

function gridcarousel(){
  // Check if Swiper is available
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper is not loaded yet. Retrying in 100ms...');
    setTimeout(gridcarousel, 100);
    return;
  }
  
  var productslider=[];
  document.querySelectorAll('.grid-mb-slider').forEach(function(Element,index){
    let productid = Element.dataset.id;
    let outer_carousel = Element.closest('.snippet-product-card.product-grid');
    let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
    let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
    let swiperObject = {
      loop: eval(Element.dataset.loop),
      slidesPerGroup: 1,
      slidesPerView: "auto",
      loop: true,
      navigation: {
        nextEl: nextbutton,
        prevEl: prevbutton,
      }
    };
    productslider[productid]=new Swiper(Element,swiperObject);
  });
}
function initializeCollectionFeatures() {
  gridcarousel();
  window.addEventListener("resize", gridcarousel);
}

if (!window.swiperScriptsManager.swiperLoaded && typeof Swiper === 'undefined') {
  const swiperScript = document.createElement('script');
  swiperScript.src = document.querySelector('script[src*="collection-section.js"]').src.replace('collection-section.js', 'slider.js');
  swiperScript.defer = true;
  swiperScript.onload = function() {
    window.swiperScriptsManager.swiperLoaded = true;
    setTimeout(initializeCollectionFeatures, 500);
  };
  swiperScript.onerror = function() {
    console.error('Failed to load Swiper library');
  };
  document.head.appendChild(swiperScript);
} else {
  setTimeout(initializeCollectionFeatures, 500);
}
var advance = function() {
  if (typeof Swiper !== 'undefined') {
    gridcarousel();
  } else {
    console.warn('Swiper not available in advance function');
  }

  setTimeout(function() {
      const elements = document.querySelectorAll('.grid-badge span, .grid-badge-pdp span');

      elements.forEach(function(span) {
          var isoCodes = span.getAttribute('data-isocode');

          if (!isoCodes) {
              span.style.display = 'block';
          } else if (isoCodes.includes(code)) {
              span.style.display = 'none';
          } else {
              span.style.display = 'block';
          }
      });
  }, 3000);

  setTimeout(function() {
      const upsellDivs = document.querySelectorAll('.main-upsell');
      let isMatchFound = false;

      if (upsellDivs) {
          upsellDivs.forEach(div => {
              const countryCode = div.getAttribute('data-val');
              if (countryCode) {
                  if (countryCode.includes(code)) {
                      div.style.display = 'flex';

                      var i = 0,
                          items = div.querySelectorAll(".pro-title"),
                          itemsHeight = [];
                      for (i = 0; i < items.length; i++)
                          itemsHeight.push(items[i].offsetHeight);
                      var maxHeight = Math.max(...itemsHeight);
                      for (i = 0; i < items.length; i++)
                          items[i].style.height = maxHeight + "px";

                      isMatchFound = true;
                  } else {
                      div.style.display = 'none';
                  }
              } else {
                  div.style.display = 'none';
              }
          });
          if (!isMatchFound && upsellDivs.length > 0) {
              upsellDivs[0].style.display = 'flex';
          }
      }
  }, 1000);
}
if(document.querySelector('.view-button') != null){
  document.querySelector('.view-button').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.add("open-view");
  })
}
window.addEventListener("scroll", (event) => {
  let widnowHeight = window.outerHeight;
  if(document.querySelector('.collection-btm-wrap') != null){
    let scrollCount = window.pageYOffset;
    let bottom_diff = document.querySelector('.collection-btm-wrap').clientHeight - document.querySelector('.collection-pagination').clientHeight
    let bottom = document.querySelector('.collection-pagination').offsetTop - document.querySelector('.collection-btm-wrap').offsetTop
    if(scrollCount >= document.querySelector('.collection-btm-wrap').offsetTop){
      if(scrollCount > (document.querySelector('.collection-btm-wrap').offsetTop + 150)){
        document.querySelector('.collection-btm-wrap').classList.add('active');
      }else{
        document.querySelector('.collection-btm-wrap').classList.remove('active');
      }
    }
  }
});

const rememberGrid = () => {
  const gridtype = sessionStorage.getItem("col-view")
  if (gridtype === 'packshot') {
    document.querySelector('#product-grid').classList.add('packshot-grid')  
  }
}
rememberGrid()

const checkViewButton = () => {
  const gridtype = sessionStorage.getItem("col-view")
  if (gridtype === 'packshot') {
     if(document.querySelector('.view-type-packshot') != null){
    document.querySelector('.view-type-packshot').classList.add('active')
     }
  } else {
    if(document.querySelector('.view-type-model') != null){
     document.querySelector('.view-type-model').classList.add('active')
      }
  }
}
checkViewButton()

document.addEventListener("DOMContentLoaded", function() {
    const productType = document.querySelector('.product-type');
    
    if (productType) {
        const listItems = productType.querySelectorAll('ul > li');
        
        if (listItems.length <= 1) {
            productType.style.display = 'none';
        }
    }
});



/* ----------------------------------------------------
   INFINITE SCROLL for Shopify Collection
   Smooth, lightweight, no external library
----------------------------------------------------- */

window.infinitescroll = {
  init() {
    const grid = document.querySelector("#product-grid");
    const pagination = document.querySelector("#AjaxinatePagination");
    if (!grid || !pagination) return;

    let loading = false;
    let nextURL = getNextURL();

    function getNextURL() {
      const link = pagination.querySelector("a");
      return link ? link.getAttribute("href") : null;
    }

    function loadProducts() {
      if (loading || !nextURL) return;

      loading = true;
      pagination.classList.add("loading");

      fetch(nextURL)
        .then((res) => res.text())
        .then((htmlString) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlString, "text/html");

          const items = doc.querySelectorAll("#product-grid .product-item");

          items.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.classList.add("fade-in-product", "loaded-product");
            clone.style.containIntrinsicSize = "auto"; 
            clone.style.contentVisibility = "visible"; 
            grid.appendChild(clone);
          });
          const newPagination = doc.querySelector("#AjaxinatePagination");
          if (newPagination) {
            pagination.innerHTML = newPagination.innerHTML;
            nextURL = getNextURL();
          } else {
            nextURL = null;
            pagination.innerHTML = `
              <div class="all-products text-center">
                <span>All products loaded</span>
              </div>`;
          }

          loading = false;
          pagination.classList.remove("loading");
        })
        .catch((err) => {
          console.error("Infinite Scroll Error:", err);
          loading = false;
          pagination.classList.remove("loading");
        });
    }

    /* Scroll trigger */
    window.addEventListener("scroll", () => {
      if (!nextURL || loading) return;

      const scrollPosition = window.innerHeight + window.scrollY;
      const triggerPoint = pagination.offsetTop - 200;

      if (scrollPosition >= triggerPoint) {
        loadProducts();
      }
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  infinitescroll.init();
});

window.addEventListener('popstate', function (event) {
    if (typeof cartdrawerupdate === "function") {
        cartdrawerupdate();
    }
});
